import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useCallback, useMemo, useState } from 'react';
import { useStoreActions } from '~/contexts';
import { useUploadLogo } from '~/hooks/useUploadLogo';
import { handleRequest } from '~/infra/utils';
import { makeDefaultBranding } from '~/store/store.utils';
const dataUrlToFile = async (dataUrl, fileName)=>{
    const res = await fetch(dataUrl);
    const blob = await res.blob();
    return new File([
        blob
    ], fileName, {
        type: blob.type || 'image/png'
    });
};
export const computeInitialBranding = (worksAt, extractedAssets)=>{
    var _ref;
    const base = (_ref = worksAt === null || worksAt === void 0 ? void 0 : worksAt.branding) !== null && _ref !== void 0 ? _ref : makeDefaultBranding();
    if (extractedAssets == null) return base;
    return _object_spread_props(_object_spread({}, base), {
        buttonPrimary: extractedAssets.brandColor,
        backgroundGradientStart: extractedAssets.gradientStart,
        backgroundGradientEnd: extractedAssets.gradientEnd,
        backgroundStandard: extractedAssets.secondaryBackground
    });
};
export const computeInitialLogoDataURL = (worksAt, extractedAssets)=>{
    var _ref, _ref1;
    var _extractedAssets_logo;
    return (_ref = (_ref1 = extractedAssets === null || extractedAssets === void 0 ? void 0 : (_extractedAssets_logo = extractedAssets.logo) === null || _extractedAssets_logo === void 0 ? void 0 : _extractedAssets_logo.data) !== null && _ref1 !== void 0 ? _ref1 : worksAt === null || worksAt === void 0 ? void 0 : worksAt.logoUrl) !== null && _ref !== void 0 ? _ref : null;
};
export function useBrandStepForm(param) {
    let { worksAt, branding, logo, setLogo } = param;
    var _ref;
    const { api, setBranding } = useStoreActions();
    const { uploadLogo, savingLogo } = useUploadLogo(worksAt);
    const [saving, setSaving] = useState(false);
    const savedBranding = useMemo(()=>{
        var _ref;
        return (_ref = worksAt === null || worksAt === void 0 ? void 0 : worksAt.branding) !== null && _ref !== void 0 ? _ref : makeDefaultBranding();
    }, [
        worksAt === null || worksAt === void 0 ? void 0 : worksAt.branding
    ]);
    const brandingDirty = useMemo(()=>branding.buttonPrimary !== savedBranding.buttonPrimary || branding.backgroundGradientStart !== savedBranding.backgroundGradientStart || branding.backgroundGradientEnd !== savedBranding.backgroundGradientEnd || branding.backgroundStandard !== savedBranding.backgroundStandard, [
        branding,
        savedBranding
    ]);
    const savedLogoUrl = (_ref = worksAt === null || worksAt === void 0 ? void 0 : worksAt.logoUrl) !== null && _ref !== void 0 ? _ref : null;
    const logoDirty = logo.file != null || logo.asDataURL !== savedLogoUrl;
    const isDirty = brandingDirty || logoDirty;
    const save = useCallback(async ()=>{
        if (!isDirty || !worksAt) return true;
        setSaving(true);
        try {
            if (logoDirty && logo.asDataURL) {
                const isAutoExtractedLogo = logo.file == null;
                try {
                    var _logo_file;
                    const file = (_logo_file = logo.file) !== null && _logo_file !== void 0 ? _logo_file : await dataUrlToFile(logo.asDataURL, 'extracted-logo.png');
                    const { success } = await uploadLogo({
                        file,
                        asDataURL: logo.asDataURL
                    }, {
                        silent: isAutoExtractedLogo
                    });
                    if (!success && !isAutoExtractedLogo) return false;
                } catch (unused) {
                    if (!isAutoExtractedLogo) return false;
                }
            }
            if (brandingDirty) {
                const { success } = await handleRequest(api.user.updateBranding(worksAt.id, branding));
                if (!success) return false;
                setBranding(branding);
            }
            return true;
        } finally{
            setSaving(false);
        }
    }, [
        isDirty,
        logoDirty,
        brandingDirty,
        logo,
        branding,
        uploadLogo,
        api,
        worksAt,
        setBranding
    ]);
    return {
        logo,
        setLogo,
        isDirty,
        save,
        saving: saving || savingLogo
    };
}
